import { Model }            from 'backbone';
import formModel            from 'formModel.js'
import undoService          from 'UndoService.js'
import textConstants        from 'TextConstants';
import listService          from 'ListService';
import constants            from 'Constants.js';
import settingsService      from 'MandatoryAndStateSettingsService.js';
import resizeController     from 'ResizeController.js';
import dateUtil             from 'shared/DateUtil.js';
import util                 from 'util/Util';
import textUtil             from 'util/TextUtil';

class MultiSelectControlModel extends Model {

    className(){
        return 'MultiSelectControlModel';
    }

    initialize() {

        this.on('change', (model) => {
            let controls = listService.selected;
            if (controls.size === 0) {
                controls = listService.previousSelected;
            }
            let beforeValue;
            _.forEach(this.changed, (value, key) => {
              if(key === 'isStateChanging' ){
                beforeValue = JSON.parse('{" state " : "' + escape(this._previousAttributes['previousStateValue']) + '"}');
              }else{                
                 beforeValue = JSON.parse('{"' + key + '" : "'+escape(this._previousAttributes[key])+'"}');
              }
            });

            controls.forEach((v,k) => {
               this.applyChanges(v.model, this.changed,model);
               v.model.resetLastState();
               v.render();
            });

            // add undo here
            // copy map from selected to use in Undo/Redo
            undoService.add({
                undo:() => {
                    controls.forEach((v,k) => {
                        this.applyChanges(v.model, beforeValue, model);
                        v.model.resetLastState();
                        v.render();
                    });
                },
                redo:() => {
                    controls.forEach((v,k) => {
                        this.applyChanges(v.model, this.changed, model);
                        v.model.resetLastState();
                        v.render();
                    });
                }
            }, textConstants.UNDO_PROP_CHANGE)

        });
    }

    applyChanges(targetModel, changedItems,model) {
        const itemsToUpdate = Object.keys(changedItems).length,
            listToChanges = ['showFooter', 'resizableColumns', 'showButtons',
            'headerHeight', 'showHeader', 'tableRowMax', 'tableRowHeight',
            'tabEnabled', 'assetId', 'stretch', 'maintainAspectRatio', 'tabIndex', 'isHidden',
            'width', 'height', 'left', 'top'];
        
        if ( targetModel.get('factoryKey') === 'control_date_input' && event.target.name === 'dateValueType' ) {
            changedItems['dateValueType'] = this.get('dateValueType');
        }
        if( targetModel.get('factoryKey') === 'control_link') {
            if (changedItems.hasOwnProperty('factoryKeys')) {
                // this is an empty refresh... shouldn't process anything
                return;
            }

            const linkOption = $('.valueType:checked').val(),
                parameter = [{
                field: '',
                id: 'default',
                literal: '',
                special: '',
                type: linkOption
            }];
    
            switch( linkOption ) {
                case 'literal':
                    parameter[0].literal = $('#TextOrNumber').val();
                    break;
                case 'field':
                    parameter[0].field = changedItems['selectedFieldName'];
                    break;
                case 'special':
                    parameter[0].special = $('#specialValue').val();
                    break;
                case 'expression':
                    parameter['Expression'] = {};
                    break;
                default:
                    break;
            }
            targetModel.set('Parameters', {Parameter: parameter}, constants.MODEL_SILENT);
        }

        _.forEach(changedItems, (value, key) => {
            let newValue = value;
            if (listToChanges.indexOf(key) !== -1) {
                targetModel.get(formModel.get('currentDevice'))[key] = newValue;
            }
            if (key === 'isStateChanging'){
                targetModel.set('state', model.attributes.state);
            } else {
                if ( key === 'width' ) {
                    // width update is being leaked only on some scenarios, skip if it's not the only update
                    if ( itemsToUpdate > 1 ) { return; } 
                    if (newValue === 0) {
                        newValue = targetModel.get('width');
                    } else if (newValue < targetModel.get('minWidth')) {
                        newValue = resizeController.getValidWidth(targetModel, parseInt(newValue));
                    }
                }
                
                if (targetModel.get('factoryKey') === 'control_date_input' && _.includes(['specificDisplay', 'dateValueType'], key) ) {
                    // Replicating code from DateUtil.updateModel()    
                    let dateValueFromProperties = this.get('dateValueType');
                    let modelShowEmpty = false,
                        modelShowNow = false,
                        modelSpecific = '';

                    switch (dateValueFromProperties.toUpperCase()) {
                        case 'EMPTY':
                            modelShowEmpty =  true;
                            newValue = '';
                            break;
                        case 'NOW':
                            modelShowNow = true;
                            newValue = dateUtil.getFormattedDate(dateUtil.convertDateToISOString(new Date()), this.get('format')) ;
                            break;
                        case 'SPECIFIC':
                            if ( this.get('specific') === '') {
                                newValue = dateUtil.getFormattedDate( dateUtil.convertDateToISOString(new Date()), this.get('format'));
                            } else {
                                newValue = this.get('specificDisplay');
                                modelSpecific = newValue;
                            }
                            break;
                    }

                    targetModel.set({
                        dateValueType: dateValueFromProperties,
                        dateValue: newValue,
                        showEmpty: modelShowEmpty,
                        showNow: modelShowNow,
                        specific: modelSpecific
                    }, constants.MODEL_SILENT);
                } else if (targetModel.get('factoryKey') === 'control_time_input' && _.includes(['specific', 'timeValueType'], key) ) {
                    // Replicating code from MainTimeValueView.setTimeValue()
                    targetModel.set('showEmpty', 'false', constants.MODEL_SILENT );
                    targetModel.set('showNow', 'false', constants.MODEL_SILENT );
                    targetModel.set('specific', '', constants.MODEL_SILENT );
            
                    if(newValue === 'Empty') {
                        targetModel.set('specific', '  :  :  ', constants.MODEL_SILENT);
                        targetModel.set('showEmpty', 'true', constants.MODEL_SILENT );
                    }
                    if(newValue === 'Now') {
                        targetModel.set('specific', new Date(), constants.MODEL_SILENT);
                        targetModel.set('showNow', 'true', constants.MODEL_SILENT );
                    }
                    if(newValue === 'Specific') {
                        if (targetModel.get('specific') === '') {
                            targetModel.set('specific','1970/01/01 12:00:00', constants.MODEL_SILENT);
                        }
            
                        $('#timeValueSpecific').attr('disabled', false);
                    }
                    targetModel.set(key, newValue, constants.MODEL_SILENT);
                } else {
                    targetModel.set(key, newValue, constants.MODEL_SILENT);
                }

                if ( targetModel.get('factoryKey') === 'control_button' ) {
                    const fontUsed = targetModel.get('fontFamily').indexOf('~') === -1 ? 'verdana' : targetModel.get('fontFamily'),
                        myText = targetModel.get('text'),
                        myFont = `${fontUsed},${targetModel.get('fontSize')}px,normal,normal`;
                    
                    const currentHeight = util.extractNum(targetModel.get('height')),
                        availableHeight = $('#aPageSel').height() - targetModel.get('top');
                    
                    let myHeight = util.measureHeight(myText, myFont);
                    
                    myHeight = availableHeight < myHeight ? availableHeight : myHeight;
                    if ( myHeight >= currentHeight ) {
                        targetModel.set('height', myHeight, constants.MODEL_SILENT);
                    }
                }

                if (key === 'fontSize' && _.includes(constants.TEXT_CONTROLS_KEYS, targetModel.get('factoryKey'))) {
                    textUtil.updateTextContent(targetModel, true);
                }
            } // else !isStateChanging
        });

    }

    defaults() {
        return {
        };
    }

}
export default MultiSelectControlModel;